<template>
    <div>
        <v-container v-if="article && article.page">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
            <h1 class="title-pg" v-if="!article.page.hide_title">{{ article.page.transTitle}}</h1>
            <div class="content" v-if="!article.page.hide_content" v-html="article.page.transContent"></div>

            <div class="news" v-if="article.children">
                <div class="news-item" v-for="child in article.children">
                    <h4>
                        <router-link
                                tag="a"
                                :to="{ name: 'article', params: { slug: child.slug }}"
                                :key="child.id"
                        >{{child.transTitle}}</router-link>
                    </h4>
                    <div class="date">{{ new Date(child.publish_date) | dateFormat('DD.MM.YYYY') }}</div>
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
    import CMS from '@/model/cms'

    export default {
        components: {
        },
        data: () => ({
            article: null,
            breadcrumbs: []
        }),
        watch: {
            // при изменениях маршрута запрашиваем данные снова
            '$route': 'fetchData'
        },
        created () {
            this.scrollToTop()
        },
        methods: {
            fetchData() {
                CMS.loadBlogBySlug(this.$route.params.slug)
                    .then(response => {
                        this.article = response.data;
                        this.breadcrumbs = [
                            {
                                text: 'Главная',
                                disabled: false,
                                href: '/'
                            },
                            {
                                text: this.article.transTitle,
                                disabled: true
                            }
                        ];
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // Прокручивание к началу страницы
            scrollToTop () {
                window.scrollTo(0, 0)
            }
        },
        mounted() {
            this.fetchData()
        }
    }
</script>

<style lang="scss" scoped>
</style>
